import axios from 'axios'

const path = 'api/messages'
export async function GetMessages () {
  return axios.get(`${window.apiConfig.APIURL + path}`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}

export async function PostMessage (json) {
  return axios.post(`${window.apiConfig.APIURL + path}`, JSON.stringify(json), {
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}
export async function GetMessagesByTaskId (id) {
  return axios.get(`${window.apiConfig.APIURL + path}/?filter.taskId=${id}`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}

export async function SetTaskAsRead (taskId) {
  return axios.put(`${window.apiConfig.APIURL + path}/readtask/${taskId}`, {},
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}

export async function PostMessageExternal (json) {
  const headers = {
    'Content-Type': 'application/json; charset=utf-8',
    Authorization: 'Bearer ' + localStorage.getItem('token')
  }

  const config = {
    url: `${window.apiConfig.APIURL + path}/external`,
    method: 'post',
    headers,
    data: JSON.stringify(json)
  }

  const delayedConfig = await scheduleRequest(config, 30000) // 6 seconds interval
  const response = await axios.request(delayedConfig)

  return response
}

function scheduleRequest (config, intervalMs) {
  let lastInvocationTime

  return new Promise((resolve) => {
    const now = Date.now()

    if (lastInvocationTime) {
      lastInvocationTime += intervalMs
      const waitPeriodForThisRequest = lastInvocationTime - now

      if (waitPeriodForThisRequest > 0) {
        setTimeout(() => resolve(config), waitPeriodForThisRequest)
      }
    }

    lastInvocationTime = now
    resolve(config)
  })
}
